import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)

  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)

  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options

  .init({
    lng: 'en',
    fallbackLng: 'en',
    load: 'languageOnly',
    ns: '',
    detection: {
      order: ['cookie', 'querystring', 'localStorage', 'navigator'],

      // keys or params to lookup language from
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
    },
    // the returned path will interpolate lng, ns if provided like giving a static path
    backend: {
      // for all available options read the backend's repository readme file
      // `${window.fromServer.env.HOST_URL}locales/{{lng}}.json`,
      loadPath: (lng: string | Array<string>) => {
        const tmp = Array.isArray(lng) ? lng[0] : lng;
        const language = tmp.replace('_', '-').split('-')[0];
        return `/locales/${language}.json`;
      },
    },

    debug: window.fromServer?.env?.HOST_URL?.includes('local'),
    interpolation: {
      escapeValue: false,
      skipOnVariables: true,
    },

    react: {
      useSuspense: true,
    },
    returnObjects: true,
    keySeparator: '.',
  });

export default i18n;
